import React from 'react';
import DocumentUploadModal from '../../modals/DocumentUploadModal';
import IntegrationsModal from '../../modals/IntegrationsModal';
import PricingModal from '../../modals/PricingModal';
import { defaultPricingLegsFor } from '../utils';

const ShipperSettingModals = ({ row, cardKey, docType, shipper, defaultPricing, defaultIntegrations, onClose }) => {
    const defaultLegs = defaultPricingLegsFor(row);

    if (cardKey === 'compliance') {
        const existingDoc = row.documents.find((document) => document.type === docType) || null;

        return (
            <DocumentUploadModal
                open
                onClose={onClose}
                type={docType}
                client_id={row.client_id}
                existingDoc={existingDoc}
                contextLabel={row.business_name}
            />
        );
    }

    if (cardKey === 'default_pricing') {
        return (
            <PricingModal
                open
                onClose={onClose}
                carrier_id={row.client_id}
                defaultPricing={defaultPricing.overrides}
                defaultLegs={defaultLegs}
                forContractor={row.isContractor}
            />
        );
    }

    if (cardKey === 'default_integration') {
        return (
            <IntegrationsModal
                open
                onClose={onClose}
                defaultIntegrations={defaultIntegrations}
                carrierId={row.client_id}
            />
        );
    }

    if (!shipper) return null;

    if (cardKey === 'integration') {
        return (
            <IntegrationsModal
                open
                onClose={onClose}
                integrations={shipper.settings.integrations}
                defaultIntegrations={defaultIntegrations}
                shipperId={shipper.client_id}
                carrierId={row.client_id}
                shipperName={shipper.business_name}
                hasCapacity={shipper.hasCapacity}
            />
        );
    }

    if (cardKey === 'pricing') {
        return (
            <PricingModal
                open
                onClose={onClose}
                carrier_id={row.client_id}
                carrierLegs={row.isContractor ? defaultLegs : row.carrier?.supply_chain_legs}
                forContractor={row.isContractor}
                carrierPricing={shipper.settings.carrierPricing}
                shipperPricing={shipper.settings.shipperPricing}
                defaultPricing={defaultPricing.overrides}
                defaultLegs={defaultLegs}
                shipper_id={shipper.client_id}
                shipperName={shipper.business_name}
            />
        );
    }

    if (cardKey === 'rate_addendum') {
        return (
            <DocumentUploadModal
                open
                onClose={onClose}
                type="RATES"
                client_id={row.client_id}
                partner_client_id={shipper.client_id}
                existingDoc={shipper.rateAddendum}
                contextLabel={shipper.business_name}
            />
        );
    }

    throw new Error(`No shipper modal for card ${cardKey}`);
};

export default ShipperSettingModals;
